module.exports = __webpack_public_path__ + "img/youxi1.11b42259.png";